export default __webpack_public_path__ + "static/media/step_documents.d944ebbc.png";